<template>

    <div :key="currentRiddleIndex_n" class="TQ_center" v-if="currentRiddleIndex_n != null">

        <div v-if="server_teamStatus_c && server_currentUserData_c && server_questBody_c"
                 class="TQ_maxWidth_750px TQ_bg_white TQ_center">

            <tq-riddle-data
                    :p_name_s="currentRiddleIndex_n + ''"

                    :p_team-status_sub-collection_e="enum_subCollection_teamStatus.MAP_MISSIONS"

                    :p_system_lang-code_e="store_system_langCode_ve.val"
                    :p_qb_display-lang-code_e="server_questBody_c.cm_qb_getDisplayLangCode_e(store_system_langCode_ve.val)"
                    :p_window-size_e="store_system_windowSizeType_ve.val"

                    :p_user-id_uid="server_currentUserData_c.ud_userId_uid"

                    :p_qb_riddle_c="co_currentMission_fc"

                    :p_players-location_by-user-id_c="server_mapPlayerLocation_byUserId_c"
                    :p_current-user-location_c="co_currentUserLocation_c"

                    :p_clues-left_n="server_teamStatus_c.ts_cluesLeft_n"
                    :p_skips-left_n="server_teamStatus_c.ts_skipsLeft_n"

                    :p_riddle-status_c="server_ts_riddles_byRiddleId_c[co_currentMission_fc.qbr_riddleId_n]"

                    :p_display-riddle-image_b="true"
                    :p_display-riddle-points_b="true"

                    :p_qb_metadata_c="server_questBody_c.qb_metadata_c"

                    :pe_click-image_f="m_clickImg_f"
                    :pe_start-watch-position_f="pe_startWatchPosition_f"
                    :pe_stop-watch-position_f="pe_stopWatchPosition_f"
                    :p_click-get-clue_f="(clueIndex, cb_f) => {m_clickGetClue_f(currentRiddleIndex_n, clueIndex, cb_f)}"
                    :p_click-skip-riddle_f="(unlocksData_byLockId, cb_f)=> {m_clickSkipRiddle_f(currentRiddleIndex_n, unlocksData_byLockId, cb_f)}"
                    :pe_rs_unlock-data_update_f="m_rs_unlockData_update_f"/>
        </div>

        <div v-else class="TQ_center">
            <ball-pulse-sync-loader color="#2E294E" size="10px"/>
        </div>

    </div>
</template>

<script>
    import {
        enum_subCollection_teamStatus} from "../../../../functions/src/shareCode/Share_S_Enum";
    import {store_var, store_getStateValue_vo, store_setStateValue} from "@/store";
    import {
        route_moveToRoute,
        route_getUrlParams,
        route_currentPath_s
    } from "../../../router";
    import {
        serverOngoing_teamPlayersGeoLocation_cl_set_f,
        serverOngoing_teamPlayersGeoLocation_cl_remove_f,
        serverOngoing_teamStatus_subCollection_cl_get_f,
        serverOngoing_teamStatus_subCollection_cl_remove_f,
        serverOngoing_teamStatusSub_riddleStatus_unlockData_update_f,
        serverOngoing_teamStatus_riddleStatus_useClue_update_f,
        serverOngoing_teamStatusSub_riddleStatus_useSkip_f,
        serverOngoing_teamStatus_vl_set_f,
        serverOngoing_teamStatus_vl_remove_f,
        serverOngoing_gameStatus_vl_set_f,
        serverOngoing_gameStatus_vl_remove_f
    } from "../../../scripts/Server/S_ServerOngoing";
    import {
        serverAuth_getOtherUserData_f
    } from "../../../scripts/Server/S_ServerAuth";
    import {serverBig_questBody_once_fp} from "../../../scripts/Server/S_ServerFirestore";
    import TqRiddleData from "../../../components/complex/TqRiddleData";
    import TqCard from "../../../components/basic/TqCard";
    import {
        enum_moveToOptions,
        enum_urlParams
    } from "../../../../functions/src/shareCode/Share_S_Enum";
    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f
    } from "../../../scripts/Server/S_ServerAuth";
    import TqImage from "../../../components/basic/TqImage";
    import TqOnTopContainer from "../../../components/basic/TqOnTopContainer";
    import {helper_finishRiddle_fb} from "@/scripts/S_Helper";
    import {FB_MapPlayerLocation} from "@/classes/client_classes";

    export default {
        name        : "V_Ongoing_PolygonMap_Riddle",
        components  : {
            TqOnTopContainer,
            TqImage,
            TqCard,
            TqRiddleData,
        },
        props:{
            pe_startWatchPosition_f:{
                type: Function,
                require: true
            },
            pe_stopWatchPosition_f:{
                type: Function,
                require: true
            }
        },
        data() {
            return {

                currentRiddleIndex_n               : null,

                // store
                store_system_langCode_ve        : store_getStateValue_vo(store_var.system_langCode),
                store_currentUserGeoLocation_vc : store_getStateValue_vo(store_var.system_currentUserLocation),
                store_questEvent_c              : store_getStateValue_vo(store_var.ongoing_questEvent).val,
                store_currentTeamId_uid         : store_getStateValue_vo(store_var.ongoing_currentTeamId_uid).val,
                store_system_windowSizeType_ve  : store_getStateValue_vo(store_var.system_windowSizeType_e).val,

                // server
                server_gameStatus_c               : undefined,
                server_teamStatus_c               : undefined,
                server_currentUserData_c          : undefined,
                server_questBody_c                : undefined,
                server_ts_riddles_byRiddleId_c    : {},

                server_mapPlayerLocation_byUserId_c : {},

                enum_subCollection_teamStatus : enum_subCollection_teamStatus,
            }
        },
        computed:{
            co_qb_displayLangCode_e(){
                return this.server_questBody_c.cm_qb_getDisplayLangCode_e(this.store_system_langCode_ve.val)
            },
            co_currentUserLocation_c(){
                if(this.server_currentUserData_c.ud_userId_uid == null || this.store_currentUserGeoLocation_vc.val == null){
                    return null
                }

                return new FB_MapPlayerLocation({
                    mpl_userId_uid      : this.server_currentUserData_c.ud_userId_uid,
                    mpl_username_s      : null,
                    mpl_dotColor_s      : "#4285F4",
                    mpl_accuracy_n      : this.store_currentUserGeoLocation_vc.val.ugl_accuracy_n,
                    mpl_latitude_n      : this.store_currentUserGeoLocation_vc.val.ugl_latitude_n,
                    mpl_longitude_n     : this.store_currentUserGeoLocation_vc.val.ugl_longitude_n,
                    mpl_timestamp_t     : this.store_currentUserGeoLocation_vc.val.ugl_timestamp_t,
                    mpl_secondsForOld_n : 5,
                })
            },
            co_currentMission_fc(){
                return this.server_questBody_c.qb_mapMissions_ac[this.currentRiddleIndex_n]
            },
        },
        methods: {
            m_clickImg_f(imgSrc_s){
                store_setStateValue(store_var.ongoing_fullScreenImage_s, imgSrc_s)
            },
            m_clickGetClue_f(riddleIndex_n, clueIndex_n, cb_f) {

                serverOngoing_teamStatus_riddleStatus_useClue_update_f({
                    questEvent_c: this.store_questEvent_c,
                    teamId_uid  : this.store_currentTeamId_uid,
                    userId_uid  : this.server_currentUserData_c.ud_userId_uid,
                    teamStatus_subCollection_e: enum_subCollection_teamStatus.MAP_MISSIONS,
                    riddleData_c: this.server_questBody_c.qb_mapMissions_ac[riddleIndex_n],
                    teamStatus_c: this.server_teamStatus_c,

                    clueId_n    : clueIndex_n,
                    clueMode_e  : this.server_questBody_c.qb_metadata_c.qbm_missions_cluesMode_e,
                    cb_f        : cb_f
                })
            },
            m_clickSkipRiddle_f(riddleIndex, unlocksData_byLockId, cb_f) {

                let riddleId_n = this.server_questBody_c.qb_mapMissions_ac[riddleIndex].qbr_riddleId_n

                serverOngoing_teamStatusSub_riddleStatus_useSkip_f({
                    questEvent_c: this.store_questEvent_c,
                    teamId_uid: this.store_currentTeamId_uid,
                    userId_uid: this.server_currentUserData_c.ud_userId_uid,
                    teamStatus_subCollection_e: enum_subCollection_teamStatus.MAP_MISSIONS,
                    riddleId_n: this.server_questBody_c.qb_mapMissions_ac[riddleIndex].qbr_riddleId_n,
                    unlocksData_byLockId: unlocksData_byLockId,

                    finishRiddle_fb : () => {
                        return helper_finishRiddle_fb(this.co_currentMission_fc, this.server_ts_riddles_byRiddleId_c[riddleId_n])
                    },
                    lastRiddle_fb : () => this.m_lastRiddle_b(riddleId_n),
                    cb_f : cb_f
                })
            },
            m_rs_unlockData_update_f(lockIndex_n, rs_unlocksData_c, cb_f) {

                let riddleData_c = this.server_questBody_c.qb_mapMissions_ac[this.currentRiddleIndex_n]

                serverOngoing_teamStatusSub_riddleStatus_unlockData_update_f({
                    questEvent_c    : this.store_questEvent_c,
                    teamId_uid      : this.store_currentTeamId_uid,
                    userId_uid      : this.server_currentUserData_c.ud_userId_uid,
                    teamStatus_subCollection_e: enum_subCollection_teamStatus.MAP_MISSIONS,
                    lockIndex_n     : lockIndex_n,

                    rs_lockData_c               : rs_unlocksData_c,
                    questSupportPoints_b        : this.server_questBody_c.qb_metadata_c.qbm_missions_supportMissionsPoints_b,

                    questLastRiddle_b           : this.m_lastRiddle_b(riddleData_c, rs_unlocksData_c),
                    riddleStatus_c              : this.server_ts_riddles_byRiddleId_c[riddleData_c.qbr_riddleId_n],
                    riddleData_c                : riddleData_c,

                    cb_f                        : cb_f
                })

            },
            m_lastRiddle_b(riddleData_c, rs_unlocksData_c){


                // 1) finish quest
                let finishQuest_b = this.server_gameStatus_c.gs_teams_byTeamId[this.store_currentTeamId_uid].gst_finishTime_t != null
                if(finishQuest_b){
                    return false
                }

                // 2) last area
                let missionsArrangementIndex_n = this.server_gameStatus_c.gs_teams_byTeamId[this.store_currentTeamId_uid].gst_missionsArrangementIndex_n
                let groupsIndex_an = this.server_questBody_c.qb_missionsArrangements_ac[missionsArrangementIndex_n].qbma_groupsIndexes_byMissionCollection_an.MAP_MISSIONS
                let lastGroupIndex_n = groupsIndex_an[groupsIndex_an.length-1]
                let missionsInLastSection_b = this.server_questBody_c.qb_mapMissionsGroup_ac[lastGroupIndex_n].qbmg_riddlesIds_an.includes(riddleData_c.qbr_riddleId_n)

                if(!missionsInLastSection_b){
                    return false
                }

                // 3) have the total points
                let ans_n = 0
                this.server_questBody_c.qb_mapMissionsGroup_ac[lastGroupIndex_n].qbmg_riddlesIds_an.forEach(loopRiddleId_n => {
                    ans_n += this.server_ts_riddles_byRiddleId_c[loopRiddleId_n] ? this.server_ts_riddles_byRiddleId_c[loopRiddleId_n].cm_rs_locksTotalPoints_n() : 0
                })
                ans_n+=rs_unlocksData_c.rsud_receivedPoints_n

                return ans_n >= this.server_questBody_c.qb_mapMissionsGroup_ac[lastGroupIndex_n].qbmg_pointsToUnlock_n

            }
        },

        // ===== life circle =====
        created(){

            // 1) get currentUserData
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (currentUserData) => {
                this.server_currentUserData_c = currentUserData;
            })

            // 2) get teamStatus
            serverOngoing_teamStatus_vl_set_f({
                viewName_s: this.$options.name, 
                questEvent_c : this.store_questEvent_c, 
                teamId_uid : this.store_currentTeamId_uid,
                cb_f: (teamStatus_c) => {
                    this.server_teamStatus_c = teamStatus_c;
                }
            })

            // 3) get gameStatus
            serverOngoing_gameStatus_vl_set_f(
                this.$options.name,
                this.store_questEvent_c.qev_questType_e,
                this.store_questEvent_c.qev_questId_uid,
                this.store_questEvent_c.qev_eventId_uid,
                true,
                (gameStatus_c) => {
                    this.server_gameStatus_c = gameStatus_c;

                })



            // 5) questBody
            serverBig_questBody_once_fp(this.store_questEvent_c.qev_questType_e, this.store_questEvent_c.qev_questId_uid, false, true, (questBody_c)=>{
                this.server_questBody_c = questBody_c

                // 4) get teamStatus subCollection riddles
                serverOngoing_teamStatus_subCollection_cl_get_f({
                    viewName_s: this.$options.name,
                    subCollectionName_e: enum_subCollection_teamStatus.MAP_MISSIONS,
                    questEvent_c: this.store_questEvent_c,
                    teamId_uid: this.store_currentTeamId_uid,
                    cb_ChildAdded_f : (riddleStatus_c) => {
                        this.$set(this.server_ts_riddles_byRiddleId_c, riddleStatus_c.rs_riddleId_n, riddleStatus_c)


                    },
                })
            })

            // 6) teamPlayerGeoLocations
            serverOngoing_teamPlayersGeoLocation_cl_set_f(this.$options.name, this.store_questEvent_c, this.store_currentTeamId_uid,
                (userGeoLocation_c) => {


                    // not location of currentUser
                    if( this.server_currentUserData_c != null &&
                        this.server_currentUserData_c.ud_userId_uid !== userGeoLocation_c.ugl_userId_uid){

                        // get current user
                        serverAuth_getOtherUserData_f(userGeoLocation_c.ugl_userId_uid, userData_c => {

                            this.$set(this.server_mapPlayerLocation_byUserId_c, userGeoLocation_c.ugl_userId_uid, new FB_MapPlayerLocation({
                                mpl_userId_uid      : userGeoLocation_c.ugl_userId_uid,
                                mpl_username_s      : userData_c.ud_name_s,
                                mpl_dotColor_s      : "green",
                                mpl_accuracy_n      : userGeoLocation_c.ugl_accuracy_n,
                                mpl_latitude_n      : userGeoLocation_c.ugl_latitude_n,
                                mpl_longitude_n     : userGeoLocation_c.ugl_longitude_n,
                                mpl_timestamp_t     : userGeoLocation_c.ugl_timestamp_t,
                                mpl_secondsForOld_n : 5,
                            }))

                        })
                    }
                })

        },
        activated(){
            this.currentRiddleIndex_n = parseInt(route_getUrlParams(this.$route,enum_urlParams.riddleId_n))


            // TODO : check when lazy load working here
            if(route_currentPath_s(this.$route).includes(enum_moveToOptions.ongoing_quest_openMap_map)){
                route_moveToRoute(enum_moveToOptions.ongoing_quest_openMap_riddle)
            }

        },
        destroyed(){
            // 1) current user
            serverAuth_currentUserData_remove_vl_f(this.$options.name)

            // 2) team status
            serverOngoing_teamStatus_vl_remove_f(this.$options.name, this.store_questEvent_c, this.store_currentTeamId_uid)

            // 3) game status
            serverOngoing_gameStatus_vl_remove_f(this.$options.name, this.store_questEvent_c)

            // 4) teamStatus subCollection riddles
            serverOngoing_teamStatus_subCollection_cl_remove_f({
                viewName_s          : this.$options.name,
                subCollectionName_e : enum_subCollection_teamStatus.MAP_MISSIONS,
                questEvent_c        : this.store_questEvent_c,
                teamId_uid          : this.store_currentTeamId_uid,
            })

            // 4) remove teamPlayerGeoLocation listener
            serverOngoing_teamPlayersGeoLocation_cl_remove_f(this.$options.name, this.store_questEvent_c, this.store_currentTeamId_uid)



        },

    }
</script>

<style scoped lang="scss">
    .root{
        height: 100%;
    }
</style>